import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueStorage from 'vue-ls'
import { VueAxios } from './utils/request'
import { Toast } from 'vant'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import rem from './utils/rem'
import Bridge from '@/utils/dsbridge'
Vue.config.productionTip = false
import'./css/common.css'
Vue.use(VueStorage)
Vue.use(VueAxios)
Vue.use(Toast)

function initCreated() {
  store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
}

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

Vue.prototype.$bridge = Bridge
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
new Vue({
  router,
  store,
  rem,
  created: initCreated,
  render: h => h(App)
}).$mount('#app')
